import React, { useEffect, useState } from "react";
import ContactMenu from "../../components/contact/ContactMenu";
import StaffCard from "../../components/card/StaffCard";
import PageBanner from "../../components/PageBanner";
import AboutUsService from "../../services/aboutUs";
import BannerService from "../../services/banner";
import { useParams } from "react-router-dom";

export default function Staff() {
  let [staffData, setStaffData] = useState([]);
  let [doctorData, setDoctorData] = useState([]);

  let [staffBanner, setStaffBanner] = useState([]);

  let { lang } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    getStaffData();
    getDoctorData();
    getStaffBanner();
  }, []);

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`/th`, "_self");
    }
  });

  const getStaffData = async () => {
    try {
      let res = await AboutUsService.getStaff();
      setStaffData(res);
    } catch {
      console.error();
    }
  };

  const getDoctorData = async () => {
    try {
      let res = await AboutUsService.getDoctor();
      setDoctorData(res);
    } catch {
      console.error();
    }
  };

  const getStaffBanner = async () => {
    try {
      let res = await BannerService.getBanner(5);
      setStaffBanner(res);
    } catch {
      console.error();
    }
  };

  const bannerText = [{ name: "Doctors and Staffs", href: "/staff" }];

  const isHead = (item) =>
    /^หัวหน้า/.test(String(item.role_TH || "").trim()) ||
    /^head\b/i.test(String(item.role_EN || "").trim());

  const staffList = staffData.list || [];
  const heads = staffList.filter(isHead);
  const members = staffList.filter((item) => !isHead(item));
  // รองอธิการบดีมาก่อน แล้วค่อยหัวหน้ากลุ่มงาน
  const executives = [...(doctorData.list || []), ...heads];

  return (
    <div id="staff" className="pt-[135px] lg:pt-[0px]">
      <PageBanner
        text_th={"บุคลากร"}
        text_en={"Doctors and Staffs"}
        banner={staffBanner?.banner}
        bannerText={bannerText}
        lang={lang}
      />

      <div className="section">
        <div className="page-container">
          {/* ติดต่อเรา */}
          <div className="mt-[35px] mb-[300px]">
            <ContactMenu isOpen={2} lang={lang} />

            {/* จัดตามผังโครงสร้างการบริหาร:
                แถว 1 รองอธิการบดี (section "Vice President")
                แถว 2 หัวหน้ากลุ่มงาน (คนในรายการ staff ที่ตำแหน่งขึ้นต้นด้วย "หัวหน้า"/"Head")
                แถว 3+ เจ้าหน้าที่ที่เหลือ แถวละ 4 คน */}
            <div id="staff-info" className="text-left mt-[44px] flex flex-col gap-[24px]">
              {executives.map((item, i) => (
                <div key={`exec-${i}`} className="flex justify-center">
                  <div className="w-full sm:w-1/2 lg:w-[calc((100%-72px)/4)]">
                    <StaffCard data={item} is_staff={true} lang={lang} />
                  </div>
                </div>
              ))}

              {members.length > 0 && (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[24px]">
                  {members.map((item, i) => (
                    <StaffCard key={i} data={item} is_staff={true} lang={lang} />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
